export default "__VITE_ASSET__DDoqkzvX__"